import type { BeforeRequestHook } from "ky";

import { readTenant, writeTenant } from "../../../logic/tenant-storage.ts";
import { getMyTenant } from "../../auth";

const ON_ERROR_REDIRECT_URL = "/oops";

/**
 * Uses the tenant defined in local storage, if present, as the
 * Tenant header.
 */
export const setTenantHeader: BeforeRequestHook = async ({ request }) => {
  let tenant = readTenant();

  if (!tenant) {
    tenant = await getMyTenant();
    if (tenant) {
      writeTenant(tenant);
    } else {
      if (window.location.pathname === ON_ERROR_REDIRECT_URL) {
        return;
      }

      window.location.assign(ON_ERROR_REDIRECT_URL);
      return;
    }
  }

  request.headers.set("Tenant", tenant);
};
